import { type GridColDef } from "@mui/x-data-grid";

import { TechCommunity } from "api/public/techCommunities/techCommunities.types";
import EmailCell from "components/MUI/DataGrid/Cells/Email.cell";
import LinkCell from "components/MUI/DataGrid/Cells/Link.cell";

export const usCommunitiesColumns: GridColDef<TechCommunity>[] = [
  {
    field: "community_name",
    headerName: "Name",
    flex: 1,
  },
  {
    field: "contact_email",
    headerName: "Contact",
    flex: 1,
    renderCell: ({ row }) => <EmailCell email={row.contact_email} />,
  },
];

export const internationalCommunitiesColumns: GridColDef<TechCommunity>[] = [
  {
    field: "community_name",
    headerName: "Name",
    flex: 1,
  },
  {
    field: "url",
    headerName: "URL",
    flex: 1,
    renderCell: ({ row }) => (
      <LinkCell to={row.url} label="Common Criteria Website" external />
    ),
  },
];
